import React, { useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Checkbox,
  Container,
  FormControlLabel,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  Radio,
  RadioGroup,
  Table,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
  TableBody,
  TableHead,
  TextField,
  Paper,
  Switch,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RegisterContainer from "container/Register";
import { useTheme } from "@mui/material/styles";
import MobileStepper from "@mui/material/MobileStepper";
import Button from "@mui/material/Button";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import { PrimaryButton } from "components/Buttons";
import Colors from "assets/Style/Colors";
import DeleteIcon from "@mui/icons-material/Delete";
import { Controller, useForm } from "react-hook-form";
import UploadFile from "components/UploadFile";
import InputField from "components/Input";
import DatePicker from "components/DatePicker";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import { FormControl } from "@mui/base";
import { Edit as EditIcon, } from "@mui/icons-material";

import SelectField from "components/Select";
import {
  agencyType,
  CleanTypes,
  Debounce,
  Debounce2,
  getFileSize,
  handleDownload,
} from "utils";
import instance from "config/axios";
import routes from "services/System/routes";
import CustomerServices from "services/Customer";
import CustomerService from "../DashboardPages/CustomerService";
import { showErrorToast, showPromiseToast } from "components/NewToaster";
import moment from "moment";
import { Link, useNavigate } from "react-router-dom";

import { FontFamily, Images } from "assets";

import { addMonths, max } from "date-fns";
import { useAuth } from "context/UseContext";
import DoDisturbIcon from "@mui/icons-material/DoDisturb";
import axios from "axios";
import UploadIcon from "@mui/icons-material/Upload";
import FinanceServices from "services/Finance";
import SearchIcon from "@mui/icons-material/Search";

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import VccServices from "services/Vcc";
import VehicleBookingServices from "services/VehicleBooking";
import UpdateRole from "../RoleManagement/UpdateRole";
import SimpleDialog from "components/Dialog/SimpleDialog";
import { Dialog } from "@mui/material";
import UserServices from "services/User";
import SystemServices from "services/System";
// import { TableBody, TableHead } from "mui-datatables";

function CreateServiceInvoice() {
  const theme = useTheme();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [selectedRow, setSelectedRow] = useState(null)
  const [editState, setEditState] = useState(false)
  const [selectedBank, setSelectedBank] = useState(null)
  const [cards, setCards] = useState([])
  const [banks, setBanks] = useState([])
  const [selectedCard, setSelectedCard] = useState(null)
  const [formChange, setFormChange] = useState(false);
  const [submit, setSubmit] = useState(false);
  const [excludeFromSales, setExcludeFromSales] = useState("no");
  const [excludeFromPurchase, setExcludeFromPurchase] = useState("no");
  const [total, setTotal] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const [payButton, setPayButton] = useState(false)
  const [rows, setRows] = useState([]);
  const [invoiceData, setInvoiceData] = useState(null)
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [settings, setSettings] = useState({})
  const [payments, setPayments] = useState([])
  const [selectedMode, setSelectedMode] = useState(null)
  console.log(rows, "data");
  const [showButton, setShowButton] = useState(false)
  const [items, setItems] = useState([
    {
      itemCode: "",
      itemDescription: "TASHEEL AUTO 19",
      totalCharge: 17.1,
      mbNo: "",
      applicationId: "",
      total: 17.1,
    },
  ]);

  // const addItem = () => {
  //   const newItem = {
  //     itemCode: "",
  //     itemDescription: "",
  //     totalCharge: 0,
  //     mbNo: "",
  //     applicationId: "",
  //     total: 0,
  //   };
  //   setItems([...items, newItem]);
  // };

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm();
  const {
    register: register1,
    handleSubmit: handleSubmit1,
    setValue: setValue1,
    getValues: getValues1,
    control,
    watch: watch1,
    formState: { errors: errors1 },
    reset: reset1,
  } = useForm();
  console.log(errors1);

  // Watch all form data

  // Watch for changes in the fee-related fields
  const govtFee = watch("govt_fee", 0);
  const centerFee = watch("center_fee", 0);
  const bankCharges = watch("bank_charge", 0);
  const qty = watch("quantity", 1);
  useEffect(() => {
    const feesTotal =
      (parseFloat(govtFee) || 0) +
      (parseFloat(centerFee) || 0) +
      (parseFloat(bankCharges) || 0);
    const finalTotal = feesTotal * (parseFloat(qty) || 1);
    setValue("total", parseFloat(finalTotal).toFixed(2));
  }, [govtFee, centerFee, bankCharges, qty]);

  const addItem = (data) => {
    console.log(data, 'datadata');

    const newSalesId = serviceItem?.id;
    const newRow = { ...data, service_id: serviceItem?.id, quantity: 1, amount: serviceItem?.charges, service: serviceItem, sales_id: newSalesId };

    setRows((prevRows) => {

      if (prevRows.length > 0) {
        const existingSalesId = prevRows[0].id;

        if (existingSalesId !== newSalesId) {
          showErrorToast("Service is already added.");
          return prevRows; // Don't add if sales_id is different
        }
      }

      // Add the item since it's the first one or has the same sales_id
      const updatedRows = [...prevRows, newRow];

      const newSubTotal = updatedRows.reduce(
        (sum, row) => sum + parseFloat(row.charges || 0),
        0
      );
      setSubTotal(parseFloat(newSubTotal.toFixed(2)));

      return updatedRows;
    });

    reset();
    setServiceItem("");
    setPayments([])
  };

  console.log(rows, 'newww');

  const [activeStep, setActiveStep] = React.useState(1);

  // const [fieldsDisabled, setFieldsDisabled] = useState({
  //   monthlyVisaServiceCharges: false,
  //   vipMedical: false,
  //   extraTyping: true,
  // });
  const [fieldsDisabled, setFieldsDisabled] = useState(false);
  const invoiceRef = useRef(null);
  const [center, setCenter] = useState(null);
  const [status, setStatus] = useState(null);
  const [chargesDisabled, setChargesDisabled] = useState(false)
  // *For Stepper Forms Data
  const [stepFormData, setStepFormData] = useState();
  const [step1FormData, setStep1FormData] = useState();
  const [selectedType, setSelectedType] = useState(null);
  const [date, setDate] = useState(new Date());
  const [balanceType, setBalanceType] = useState(null);
  const [imageURL, setImageURL] = useState(null);
  const fileInputRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [salesAccount, setSalesAccount] = useState(null);
  const [inventoryAccount, setInventoryAccount] = useState(null);
  const [cogsAccount, setCogsAccount] = useState(null);
  const [adjustmentAccount, setAdjustmentAccount] = useState(null);
  const [assemblyAccount, setAssemblyAccount] = useState(null);
  const [itemType, setItemType] = useState(null);
  const [unit, setUnit] = useState(null);
  const [customers, setCustomers] = useState([])
  const [taxes, setTaxes] = useState([]);
  const [tax, setTax] = useState(null);
  const [category, setCategory] = useState(null);
  const [categories, setCategories] = useState(null);
  const [governmentAccount, setGovernmnentAccount] = useState(null);
  const [description, setDescription] = useState(null);
  const [ownGovBank, setOwnGovBank] = useState(null);
  const [services, setServices] = useState([]);
  const [serviceItem, setServiceItem] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [detail, setDetail] = useState(null);
  const [holdState, setHoldState] = useState(true);
  const [loader, setLoader] = useState(false)
  const [vins, setVins] = useState([])
  const [selectedVin, setSelectedVin] = useState(null)
  const [isVatApplicable, setIsVatApplicable] = useState(false)
  const [vat, setVat] = useState(0)
  const [open, setOpen] = useState(false)
  const [serviceItemList, setServiceItemList] = useState([])
  // const [fieldsDisabled, setFieldsDisabled] = useState(false)

  //documents array

  const handleNext = () => {
    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  // *For Get Customer Queue
  const getBanks = async (page, limit, filter) => {
    setLoader(true)

    try {
      const params = {
        page: 1,
        limit: 999999,
      }

      const { data } = await CustomerServices.getBanks(params)
      setBanks(data?.banks)
    } catch (error) {
      showErrorToast(error)
    } finally {
      setLoader(false)
    }
  }
  // *For Get Customer Queue
  const getCards = async (page, limit, filter) => {
    setLoader(true)

    try {
      const params = {
        page: 1,
        limit: 999999,
      }

      const { data } = await CustomerServices.getCards(params)
      let cardsData = data?.cards?.map((card) => ({
        ...card,
        name: card.account_name,
      }));
      setCards(
        data?.cards?.map((card) => ({
          ...card,
          name: card.account_name,
        })),

      )

      setSelectedCard({ id: cardsData[0]?.id, name: cardsData[0]?.name, account_id: cardsData[0]?.account_id })
      setValue1("card", { id: cardsData[0]?.id, name: cardsData[0]?.name, account_id: cardsData[0]?.account_id })


    } catch (error) {
      showErrorToast(error)
    } finally {
      setLoader(false)
    }
  }

  const getServiceItems = async (page, limit, filter) => {
    // setLoader(true)
    try {

      let params = {
        page: 1,
        limit: 999999,

      }
      params = { ...params }

      const { data } = await CustomerServices.getServiceItemList(params)
      setServiceItemList(data?.rows)




    } catch (error) {
      console.log(error);

      showErrorToast(error)
    } finally {
      // setLoader(false)
    }
  }

  const round = (num) => Math.round(num * 100) / 100;

  const addPayments = (amount, mode, bank, card, code, percentage = 0, additionalCharges = null, submit = null) => {
    const total = parseFloat(getValues1("total")) || 0;
    const currentAmount = parseFloat(amount) || 0;
    const existingTotal = payments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
    let sum = existingTotal + currentAmount;

    // Convert to fixed decimals and parse back to numbers
    let formattedSum = parseFloat(sum.toFixed(2));
    let formattedTotal = parseFloat(total.toFixed(2));

    console.log("Formatted Sum:", formattedSum);
    console.log("Formatted Total:", formattedTotal);
    console.log("Comparison:", formattedSum > formattedTotal);

    if (formattedSum > formattedTotal) {
      showErrorToast("Total payment exceeds the required amount.");
      return;
    }

    if (!amount) {
      showErrorToast("Amount is required");
      return;
    }

    if (parseFloat(amount) === 0) {
      showErrorToast("Amount is 0");
      return;
    }

    if (!mode) {
      showErrorToast("Payment mode is required");
      return;
    }

    if (mode === "Bank" && !bank) {
      showErrorToast("Bank is required for Bank mode");
      return;
    }



    if (mode === 700260 && !code) {
      showErrorToast("Authorization code is required for Card mode");
      return;
    }

    // if ((mode === "Payment Link" || mode === 700260) && (!percentage || isNaN(percentage))) {
    //     showErrorToast("Percentage is required for Bank/Card mode");
    //     return;
    // }

    const paymentObj = {
      amount: currentAmount,
      payment_mode: 'Card-MOHRE',
      account_id: mode,
      ref_id: mode === "Bank" ? bank?.id : mode === 700260 ? card?.id : null,
      ref_name: mode === "Bank" ? bank?.name : mode === 700260 ? card?.name : null,
      auth_code: mode === 700260 ? code : null,
      additional_charges_percentage: mode === "Payment Link" || mode === 700260 ? parseFloat(percentage) : null,
      additional_charges_value: mode === "Payment Link" || mode === 700260 ? parseFloat(additionalCharges || 0) : null,
    };

    setPayments((prev) => [...prev, paymentObj]);

    // Reset form fields
    setSelectedBank(null);
    setSelectedCard(null);
    setValue1("payamount", "");
    // setValue1("percentage", "");
    // setValue1("additionalCharges", "");
    setValue1("remarks", "");
    setValue1("authCode", "");
    // Optionally reset payment mode
    // setValue1("payment", { id: "Cash", name: "Cash" });
    // setSelectedMode({ id: "Cash", name: "Cash" });
  };

  useEffect(() => {
    console.log(payments, 'paymentspayments');

    const total = parseFloat(getValues1("total")) || 0;
    const existingTotal = payments.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);
    console.log(total, 'total');
    console.log(existingTotal, 'existingTotal');
    console.log(total, 'total');
    console.log(parseFloat(parseFloat(total) - parseFloat(existingTotal)), 'minusval');

    setValue1('amount', parseFloat(existingTotal).toFixed(2))
    setValue1('balance', parseFloat(parseFloat(parseFloat(total) - parseFloat(existingTotal))).toFixed(2))
    setValue1('payamount', parseFloat(parseFloat(parseFloat(total) - parseFloat(existingTotal))).toFixed(2))

    if (payments?.length > 0) {
      setChargesDisabled(true)
    }
    else if (payments?.length == 0) {
      setChargesDisabled(false)
    }
    // setValue1("payment", { id: "Cash", name: "Cash" })
    // setSelectedMode({ id: "Cash", name: "Cash" })
  }, [payments])

  const generatePDF = async () => {
    if (!invoiceRef.current) return;

    // Temporarily show the content while generating the PDF
    const invoiceElement = invoiceRef.current;
    invoiceElement.style.display = "block"; // Show the element

    // Capture the content using html2canvas
    const canvas = await html2canvas(invoiceElement, {
      scale: 2, // Higher scale for better quality
      useCORS: true,
      logging: false,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "mm",
      format: "a4",
    });

    // A4 dimensions: 210mm × 297mm
    const pageWidth = 210;
    const pageHeight = 297;

    // Calculate dimensions to fit content on page with margins
    const margin = 14; // 14mm margins
    const contentWidth = pageWidth - (margin * 2);

    // Calculate height while maintaining aspect ratio
    const contentHeight = (canvas.height * contentWidth) / canvas.width;

    // Check if content would exceed page height and scale if necessary
    const availableHeight = pageHeight - (margin * 2);
    const scale = contentHeight > availableHeight ? availableHeight / contentHeight : 1;

    // Calculate final dimensions
    const finalWidth = contentWidth * scale;
    const finalHeight = contentHeight * scale;

    // Add image to the PDF with margins
    pdf.addImage(imgData, "PNG", margin, margin, finalWidth, finalHeight);

    const blob = pdf.output("blob");

    // Create a blob URL
    const blobUrl = URL.createObjectURL(blob);

    // Open the PDF in a new tab
    window.open(blobUrl);
    navigate('/pre-sales')
    // Restore the content visibility after generating the PDF
    invoiceElement.style.display = "none"; // Hide the element again
  };


  const submitForm1 = async () => {
    setButtonDisabled(true);

    const updatedRows = rows.map(({ id, ...rest }) => ({
      ...rest,
      service_id: id,
    }));
    console.log(updatedRows, 'updatedRowsupdatedRows');


    try {
      let obj = {

        reference_number: getValues1('reference_no'),
        invoice_date: moment(date).format('MM-DD-YYYY'),
        amount: subTotal,
        tax: 0,
        total: subTotal,
        customer_id: selectedCustomer?.id,
        invoice_details: updatedRows,
      };

      console.log(obj, "obj from getValues1");

      // const apiPromise = CustomerServices.CreateSaleReceipt(obj);

      // showPromiseToast(apiPromise, "Saving...", "Added Successfully", "Something Went Wrong");

      // const response = await apiPromise;

      // if (response?.responseCode === 200) {
      //     navigate("/pre-sales");

      //     const invoice = {
      //         id: response?.data?.id,
      //         created_by: response?.data?.creator,
      //         payment_creator: response?.data?.payment_creator,
      //         date: moment(date).format("DD-MM-YYYY"),
      //         invoiceType: getValues1('invoice_no'),
      //         trn: getValues1('trn'),
      //         tokenNumber: getValues1('token'),
      //         email: getValues1('email'),
      //         customerName: getValues1('display_customer'),
      //         mobileNo: getValues1('mobile'),
      //         customerReference: getValues1('reference_no'),
      //         customerAddress: getValues1('address'),
      //         items: rows,
      //         totalSales: 367.25,
      //         netTaxableAmount: 27.5,
      //         totalVAT: 1.38,
      //         grossTotal: 396.13,
      //         customerCardPayment: 0.0,
      //         totalPayable: 396.13,
      //     };

      //     console.log(invoice, 'invoice');
      //     setInvoiceData(invoice);
      // }

    } catch (error) {
      ErrorToaster(error);
    } finally {
      setButtonDisabled(false);
    }
  };


  const submitForm2 = async () => {

    const requiredFields = [
      { label: "Customer", value: selectedCustomer?.id },
      { label: "Date", value: date },
      { label: "Reference Number", value: getValues1('reference_no') },


    ];


    const missingField = requiredFields.find(field => !field.value);
    console.log(missingField, 'missingFieldmissingField');

    if (missingField?.label) {
      showErrorToast(`${missingField.label} is required`);
      return;
    }
    console.log(rows, 'rows');
    const newSubTotal = rows.reduce(
      (sum, row) => sum + parseFloat(row.price || 0),
      0
    );
    console.log(newSubTotal);

    const TotalCharges = rows.reduce(
      (sum, row) => sum + parseFloat(row.chargesaed || 0),
      0
    );
    console.log(newSubTotal);

    const newArray = rows?.map(item => ({
      vehicle_id: item?.id,
      vin: item?.vin,

      charges: item?.chargesaed,
      sales_price: item?.price

    }));
    try {
      let obj = {
        reference_number: getValues1('reference_no'),
        due_date:
          selectedCustomer?.due_date_policy === 'Instant'
            ? moment(date).format('MM-DD-YYYY')
            : moment(date)
              .add(
                parseInt(selectedCustomer?.due_date_policy?.match(/\d+/)?.[0] || 0),
                'days'
              )
              .format('MM-DD-YYYY'),
        invoice_date: moment(date).format('MM-DD-YYYY'),
        amount: subTotal,
        tax: 0,
        total: subTotal,
        customer_id: selectedCustomer?.id,
        invoice_details: rows,

      };

      console.log(obj, "obj from getValues1");

      const apiPromise = CustomerServices.CreateServiceInvoice(obj);

      showPromiseToast(apiPromise, "Saving...", "Added Successfully", "Something Went Wrong");

      const response = await apiPromise;

      if (response?.responseCode === 200) {
        navigate("/service-invoice");



      }

    } catch (error) {
      ErrorToaster(error);
    } finally {
      setButtonDisabled(false);
    }



  };

  // *For Get Account
  const getReceptionDetail = async (value) => {
    setFieldsDisabled(true);

    try {
      let params =
        value === "token"
          ? { token_number: getValues1("token") }
          : { mobile: getValues1("mobileValue") };

      const { data } = await CustomerServices.getReceptionDetail(params);
      if (!data.token) {
        ErrorToaster("Token might be expired or invalid");
        return;

      }
      if (data?.token?.created_at) {
        const tokenDate = moment(data.token.created_at);
        const today = moment().startOf('day');
        if (!tokenDate.isSame(today, 'day')) {
          ErrorToaster("Token might be expired or invalid");
          return;
        }
      }
      console.log(data, "dataaa");
      setDetail(data?.token);
      setSelectedCustomer({ id: data?.token?.customer_id, name: data?.token?.customer?.name });
      setValue1("customer", { id: data?.token?.customer_id, name: data?.token?.customer?.name });
      //setValue1("customer", data?.token?.customer_name);
      setValue1("invoice_date", moment().toDate());
      setValue1("mobile", data?.token?.mobile);
      setValue1("reference_no", data?.token?.reference);
      setValue1("display_customer", data?.token?.customer_name);
      setValue1("email", data?.token?.email);
      setValue1("address", data?.token?.address);
      if (value === "token") {
        setValue1("mobileValue", data?.token?.mobile);
      }
      else {
        setValue1("token", data?.token?.token_number);
      }



      setAccounts(data?.accounts?.rows);

      getServiceItem(data?.token?.service_category?.id);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };


  const getServiceItem = async (id) => {
    console.log(user, 'useruser');

    // setLoader(true)
    try {

      const categoryIds = user?.categories?.map(category => category?.category_id).join(',');
      console.log(categoryIds, "cats");
      let params = {
        page: 1,
        limit: 999999,
        category_id: categoryIds,
      };

      const { data } = await CustomerServices.getServiceItem(params);

      const mappedServices = data?.rows.map(item => ({
        ...item,
        name: `${item.name} - ${item.name_ar}`,
      }));

      setServices(mappedServices);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };
  const getInvoiceNumber = async () => {
    // setLoader(true)
    try {
      const { data } = await CustomerServices.getInvoiceNumber();

      console.log(data);
      setValue1("invoice_no", `${data?.invoice_number}`);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };

  const getSystemSettings = async () => {
    // setLoader(true)
    try {
      const { data } = await CustomerServices.getSystemSettings();

      console.log(data, "settings");
      setSettings(data?.settings)
      setValue1("cost_center", { id: data?.settings?.cost_center, name: data?.settings?.cost_center })

      // setValue1("invoice_no", `DED/${data?.next_invoice_number}`);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };

  const handleServiceSelect = async (value) => {
    console.log(value, "idididid");
    setServiceItem(value);
    if (value) {
      setValue('charges', value?.charges)


    }
    else {
      setValue("id", '');
      setValue("govt_fee", '');
      setValue("center_fee", '');
      setValue("bank_charge", '');
      setValue("transaction_id", '');
      setValue("application_id", '');
      setValue("ref_no", '');
      setServiceItem(null);
      setValue("quantity", '');
    }

  };


  const getAccounts = async (page, limit, filter) => {
    // setLoader(true)
    try {
      let params = {
        page: 1,
        limit: 999999,
      };

      const { data } = await FinanceServices.getAccounts(params);
      console.log(data?.accounts?.rows);

      setAccounts(data?.accounts?.rows);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };
  // *For Get Account
  const getReceiptDetail = async (state) => {
    setFieldsDisabled(true);
    try {
      let params = {
        token_number: getValues1("token"),
        invoice_date: date,
      };

      const { data } = await CustomerServices.getReceiptDetail(params);
      console.log(data);
      if (data?.receipt) {
        setHoldState(true);

        showErrorToast("Invoice already exist with this token number");
      } else {
        getReceptionDetail("token");
        setHoldState(false);
      }
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };
  const getTax = async () => {
    // setLoader(true)
    try {
      let params = {
        page: 1,
        limit: 999999,
      };

      const { data } = await FinanceServices.getTax(params);
      console.log(data?.accounts?.rows);

      setTaxes(data?.tax);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };
  const getCategories = async () => {
    // setLoader(true)
    try {
      let params = {
        page: 1,
        limit: 999999,
      };

      const { data } = await CustomerServices.getCategoryList(params);

      setCategories(data?.categories);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      // setLoader(false)
    }
  };
  const updateItem = (data) => {
    console.log("Raw data passed to updateItem:", data);
    console.log("Current serviceItem:", serviceItem);

    if (!serviceItem?.id) {
      console.warn("No valid service_id found in serviceItem. Skipping update.");
      return;
    }

    const updatedSalesId = serviceItem?.sales_account_id;

    const updatedItem = {
      ...data,
      service_id: serviceItem?.id,
      quantity: 1,
      amount: serviceItem?.charges,
      service: serviceItem,
    };
    console.log("Updated item to be saved:", updatedItem);

    setRows((prevItems) => {
      console.log("Previous rows:", prevItems);

      const updatedRows = prevItems.map((item) => {
        if (item.service_id === serviceItem?.id) {
          console.log(`Item with service_id ${item.service_id} matched. Replacing with updated item.`);
          return updatedItem;
        }
        return item;
      });

      console.log("Rows after update:", updatedRows);

      // Calculate new subtotal
      const newSubTotal = updatedRows.reduce((sum, row) => {
        const total = parseFloat(row.charges || 0);
        return sum + (isNaN(total) ? 0 : total);
      }, 0);

      setSubTotal(parseFloat(newSubTotal.toFixed(2)));
      return updatedRows;
    });

    console.log("Resetting form and states...");
    reset();
    setServiceItem(null);
    setEditState(false);
  };

  useEffect(() => {
    console.log(rows, 'rowsrowsrows');
    const newSubTotal = rows.reduce(
      (sum, row) => sum + parseFloat(row.price || 0),
      0
    );
    if (isVatApplicable) {
      setVat(parseFloat(parseFloat(newSubTotal) * 0.05).toFixed(2))
    }
    else {
      setVat(parseFloat(0).toFixed(2))
    }



  }, [isVatApplicable, editState])


  useEffect(() => {
    console.log(rows, 'rowsrows');
    if (rows?.length == 0) {
      setPayButton(false)
      setPayments([])
      setSelectedMode(null)
    }
    const allowedCategories = [13, 14, 15, 16, 17];
    setValue1('total', (
      parseFloat(subTotal) +
      rows?.reduce((total, item) => {
        const fee = parseFloat(item?.center_fee ?? 0);
        const qty = parseFloat(item?.quantity ?? 1);
        return total + fee * qty;
      }, 0) * 0.05
    ).toFixed(2))
    setValue1('balance', (
      parseFloat(subTotal) +
      rows?.reduce((total, item) => {
        const fee = parseFloat(item?.center_fee ?? 0);
        const qty = parseFloat(item?.quantity ?? 1);
        return total + fee * qty;
      }, 0) * 0.05
    ).toFixed(2))
    setValue1('payamount', (
      parseFloat(subTotal) +
      rows?.reduce((total, item) => {
        const fee = parseFloat(item?.center_fee ?? 0);
        const qty = parseFloat(item?.quantity ?? 1);
        return total + fee * qty;
      }, 0) * 0.05
    ).toFixed(2))
    setValue1('finalTotal', (
      parseFloat(subTotal) +
      rows?.reduce((total, item) => {
        const fee = parseFloat(item?.center_fee ?? 0);
        const qty = parseFloat(item?.quantity ?? 1);
        return total + fee * qty;
      }, 0) * 0.05
    ).toFixed(2))
    rows?.map((row) => {
      if (allowedCategories.includes(row?.service?.category_id)) {
        setShowButton(true);
      } else {
        setShowButton(false);
      }
    });
  }, [rows]);

  const getVinsLots = async () => {
    try {
      const { data } = await VccServices.getVins()

      let vin = data?.vins.map((item) => { return { id: item, name: item } })
      let lot = data?.lots.map((item) => { return { id: item, name: item } })
      const uniqueVins = Array.from(new Set(vin.map(item => item.id)))
        .map(id => vin.find(item => item.id === id));
      const uniqueLots = Array.from(new Set(lot.map(item => item.id)))
        .map(id => lot.find(item => item.id === id));

      setVins(uniqueVins)

    } catch (error) {
      ErrorToaster(error)
    }
  }

  useEffect(() => {
    getInvoiceNumber()
    console.log(user, "user");
    getAccounts();
    getVinsLots()
    getTax();
    // getCards();
    // getBanks()
    getCategories();
    getSystemSettings();
    // getServiceItem();
    // getInvoiceNumber();
    setSelectedCustomer();
    setValue1("customer",);
    setValue1("cost_center", { id: settings?.cost_center, name: settings?.cost_center })
  }, []);

  const getVehicleBookings = async (vin) => {
    setLoader(true)
    try {

      let params = {
        page: 1,
        limit: 9999999,
        vins: vin
      }
      params = { ...params }
      const { data } = await VehicleBookingServices.getVehicleBookings(params)
      console.log(data);


    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }
  const getCustomerDropDown = async (search) => {
    try {
      let params = {
        page: 1,
        limit: 50,
        name: search
      }
      const { data } = await CustomerServices.getCustomerQueue(params)
      setCustomers(data?.rows)
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const getCustomerDetail2 = async (id) => {
    try {
      let params = {
        customerID: id,
      };

      const { data } = await CustomerServices.getCustomerDetail(params);
      let detail = data?.user;
      console.log(detail, 'detaildetail')
      setValue1("customer", detail?.name);
      setValue1("invoice_date", moment().toDate());
      setValue1("mobile", detail?.uae_phone);
      setValue1("reference_no", detail?.token?.reference);
      setValue1("display_customer", detail?.name);
      setValue1("email", detail?.email);
      setValue1("address", detail?.token?.address);

      // setAccounts(detail?.accounts?.rows);

      // getServiceItem(detail?.token?.service_category?.id);
    } catch (error) {
      console.error("Error fetching location:", error);
    }
  };

  const addCustomer = async (formData) => {
    setOpen(false)

    console.log(formData, 'formData');

    try {
      const commonData = {
        name: formData.name,
        address: formData.address,
        uae_phone: formData?.mobile,

        email: formData?.email,
        currency: "aed",
        user_type_id: 'C',


        business_region: 'import',
        import: true,
        ap_document: [],
        gender: "male",
        customer_type: 1,
      }




      console.log(commonData, 'commonDatacommonData')
      const { message, data } = await UserServices.createUser(commonData)
      SuccessToaster(message)

      getCustomerDropDown()
      console.log(data);

      setSelectedCustomer(data?.userData)
      reset1()

    } catch (error) {
      console.log(error);

      ErrorToaster(error)
    }
  }
  const [currencies, setCurrencies] = useState([])
  const getCurrencies = async (defaultId) => {
    try {
      let params = {
        detailed: true
      }
      const { data } = await SystemServices.getCurrencies(params)
      const currenciesArray = []
      data?.currencies?.forEach(element => {
        let obj = {
          id: element?.currency,
          name: element?.currency.toUpperCase(),
          rate: element?.conversion_rate
        }
        currenciesArray.push(obj)
      });
      console.log(currenciesArray, 'currenciesArray');


      setCurrencies(currenciesArray)

    } catch (error) {
      ErrorToaster(error)
    }
  }
  useEffect(() => {
    getCurrencies()
    getServiceItems()
    getCustomerDropDown()
  }, [])

  return (
    <>
      <SimpleDialog
        open={open}
        onClose={() => setOpen(false)}
        title={"Add Customer"}
      >
        <Box component="form" onSubmit={handleSubmit1(addCustomer)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <InputField
                size={"Name"}
                label={"Name"}
                placeholder={"Name"}
                register={register1("name", {
                  required: 'name is required'
                })}
                error={errors1?.name?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <InputField

                label={"Email"}
                placeholder={"Email"}
                register={register1("email", {
                  required: false
                })}
                error={errors1?.email?.message}
              />
            </Grid>
            <Grid item xs={12}>
              <InputField
                label={"Mobile "}

                placeholder={"Mobile "}
                type={'number'}
                error={errors1?.mobile?.message}
                register={register1("mobile", {
                  required:
                    'please enter mobile number',
                  pattern: {
                    value: /^05[0-9]{8}$/,
                    message: "Please enter a valid UAE mobile number (starting with 05 and 8 digits)."
                  }

                })}
              />
            </Grid>
            <Grid item xs={12}>
              <InputField

                label={"Address"}
                placeholder={"Address"}
                register={register1("address", {
                  required: false
                })}
                error={errors1?.address?.message}
              />
            </Grid>
            <Grid item xs={12} sx={{ mt: 2, textAlign: "center" }}>
              <PrimaryButton title="Submit" type="submit" />
            </Grid>
          </Grid>
        </Box>
      </SimpleDialog>
      <Box m={3} sx={{ backgroundColor: "white", borderRadius: "12px" }}>
        <Box component={"form"} onSubmit={handleSubmit1(submitForm1)}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: "10px",
                p: 3,
                alignItems: "flex-end",
              }}
            >
              <Typography variant="h5"
                sx={{
                  color: Colors.charcoalGrey,
                  fontFamily: FontFamily.NunitoRegular,
                  mb: 4,
                  mt: 2
                }}>
                Create Sale Invoice
              </Typography>

            </Box>

            <Box sx={{ p: 3 }}>
              <Grid container sx={{ gap: "5px 25px" }}>
                {/* <Grid item xs={12}>
                                    <Grid item xs={12}>
                                        <Grid container gap={2} alignItems={"center"}>
                                            <Grid item md={3} sm={12} xs={12}>
                                                <InputField
                                                    label="Token"
                                                    size="small"
                                                    disabled={fieldsDisabled}
                                                    placeholder="Enter Token"
                                                    register={register1("token")}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <IconButton
                                                                onClick={() => {
                                                                    getReceiptDetail();


                                                                }}
                                                            >
                                                                <SearchIcon sx={{ color: "#001f3f" }} />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item md={3} sm={12} xs={12}>
                                                <InputField
                                                    label={"Mobile *:"}
                                                    size={"small"}
                                                    type={"number"}
                                                    disabled={fieldsDisabled}
                                                    placeholder={"Mobile"}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <IconButton
                                                                onClick={() => {
                                                                    getReceiptDetail();


                                                                }}
                                                            >
                                                                <SearchIcon sx={{ color: "#001f3f" }} />
                                                            </IconButton>
                                                        ),
                                                    }}
                                                    register={register1("mobileValue", {
                                                        required: false,

                                                        onChange: (e) => {
                                                            console.log("asdas");
                                                            if (getValues1("mobileValue").length == 10) {
                                                                //  getReceiptDetail()
                                                            }

                                                            // Delay the execution of verifyEmail by 2 seconds
                                                        },
                                                    })}
                                                />
                                            </Grid>
                                            <Grid item md={1} sm={12} xs={12} mt={2}>
                                                <PrimaryButton
                                                    bgcolor={"#001f3f"}
                                                    title="Clear"
                                                    onClick={() => {
                                                        setFieldsDisabled(false);
                                                        setValue1("customer", "");
                                                        setValue1("invoice_date", moment().toDate());
                                                        setValue1("mobile", "");
                                                        setValue1("reference_no", "");
                                                        setValue1("display_customer", "");
                                                        setValue1("email", "");
                                                        setValue1("address", "");

                                                        setValue1("mobileValue", "");


                                                        setAccounts("");
                                                    }}
                                                // loading={loading}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                <Grid
                  item
                  md={12}
                  sm={12}
                  xs={12}
                  sx={{
                    border: "2px solid black",
                    p: 2,
                    borderRadius: "15px",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={4}>
                      <SelectField
                        size={"small"}
                        label={"Customer"}

                        options={customers}
                        selected={selectedCustomer}
                        onSelect={(value) => {
                          setSelectedCustomer(value);
                          console.log(value);
                          setValue1('name', value?.name)
                          setValue1('email', value?.email)
                          setValue1('phone', value?.phone)
                          // getCustomerDetail2(value?.id)

                        }}
                        error={errors1?.vin?.message}
                        register={register1("vin", {
                          required: false,
                        })}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <DatePicker
                        label={"Invoice Date"}
                        value={date}
                        disableFuture={true}
                        size={"small"}
                        error={errors1?.invoice_date?.message}
                        register={register1("invoice_date", {
                          required: date ? false : "please enter date.",
                        })}
                        maxDate={new Date()}
                        onChange={(date) => {
                          setValue1("invoice_date", date)
                          setDate(new Date(date))
                        }}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputField
                        label="Reference No"
                        size="small"

                        placeholder="Reference No"
                        register={register1("reference_no", {
                          required: "please enter reference no.",
                        })}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputField
                        label="Name"
                        size="small"
                        disabled={true}
                        placeholder="Name"
                        register={register1("name")}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputField
                        label="Email"
                        size="small"
                        disabled={true}
                        placeholder="Email"
                        register={register1("email")}
                      />
                    </Grid>
                    <Grid item xs={4}>
                      <InputField
                        label="Phone"
                        size="small"
                        disabled={true}
                        placeholder="Phone"
                        register={register1("phone")}
                      />
                    </Grid>


                    {/* <Grid item xs={6}>
                      <SelectField
                        size={"small"}
                        label={"Sale Type"}

                        options={[
                          { id: 'Local', name: 'Local' },
                          { id: 'Makasa', name: 'Makasa' },
                          { id: 'Export', name: 'Export' }
                        ]}
                        selected={selectedType}
                        onSelect={(value) => {
                          setSelectedType(value);


                        }}
                        error={errors1?.type?.message}
                        register={register1("type", {
                          required: false,
                        })}
                      />
                    </Grid> */}
                    <Grid item xs={12}>
                      <InputField
                        label="Notes"
                        size="small"
                        placeholder="Add notes or comments..."
                        multiline
                        rows={3}
                        register={register1("notes", {
                          required: false,
                        })}
                        error={errors1?.notes?.message}
                      />
                    </Grid>
                  </Grid>
                </Grid>

              </Grid>
            </Box>

          </Box>
        </Box>
        <form onSubmit={handleSubmit(!editState ? addItem : updateItem)}>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>

                  <TableCell sx={{ width: "400px" }}>Services</TableCell>


                  <TableCell sx={{ width: "150px" }}>Charges</TableCell>
                  <TableCell sx={{ width: "400px" }}>Description</TableCell>

                  <TableCell sx={{ width: "150px" }}>Action</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>




                  <TableCell>
                    <SelectField
                      size="small"
                      options={serviceItemList}
                      disabled={detail?.is_paid || editState}
                      selected={serviceItem}
                      onSelect={handleServiceSelect}
                      register={register("service", {
                        validate: value => value !== "" || "Please select a service.",
                      })}
                    />
                    {errors.service && <span style={{ color: "red" }}>{errors.service.message}</span>}
                  </TableCell>






                  <TableCell>
                    <InputField
                      size="small"
                      // disabled={true}
                      placeholder="Charges"
                      type="text"
                      inputMode="decimal"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ","].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      register={register("charges", {
                        required: "charges are required",

                      })}
                    />
                    {errors.charges && <span style={{ color: "red" }}>{errors.charges.message}</span>}
                  </TableCell>


                  <TableCell>
                    <InputField
                      size="small"

                      placeholder="Description"
                      type="text"

                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-", ","].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      register={register("description", {
                        required: "description is required",

                      })}
                    />
                    {errors.description && <span style={{ color: "red" }}>{errors.description.message}</span>}
                  </TableCell>



                  <TableCell>
                    {!editState && !detail?.is_paid && (
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        sx={{
                          textTransform: "capitalize",
                          backgroundColor: "#001f3f",
                          fontSize: "12px",
                          ":hover": {
                            backgroundColor: "#001f3f",
                          },
                        }}
                      >
                        <AddIcon />
                      </Button>
                    )}
                    {editState && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          type="submit"
                          sx={{
                            textTransform: "capitalize",
                            backgroundColor: "#001f3f",
                            fontSize: "12px",
                            ":hover": {
                              backgroundColor: "#001f3f",
                            },
                          }}
                        >
                          Update
                        </Button>
                        <Button
                          variant="contained"
                          color="primary"
                          onClick={() => {
                            setEditState(false);
                            setValue("id", "");
                            setValue("item_code", "");
                            setValue("govt_fee", "");
                            setValue("center_fee", "");
                            setValue("bank_charge", "");
                            setValue("transaction_id", "");
                            setValue("application_id", "");
                            setValue("ref_no", "");
                            setServiceItem(null);
                            setValue("quantity", "");
                          }}
                          sx={{
                            mt: 2,
                            textTransform: "capitalize",
                            backgroundColor: "#001f3f",
                            fontSize: "12px",
                            ":hover": {
                              backgroundColor: "#001f3f",
                            },
                          }}
                        >
                          Cancel
                        </Button>
                      </>
                    )}
                  </TableCell>
                </TableRow>




                {rows?.length > 0 && rows?.map((item, index) => (
                  <TableRow key={index}>
                    <TableCell sx={{ display: "none" }}>{item?.id}</TableCell>

                    <TableCell>{item?.service?.name}</TableCell>

                    <TableCell>{item?.charges}</TableCell>

                    <TableCell>{item?.description}</TableCell>

                    <TableCell>
                      <Box sx={{ display: 'flex', gap: 1 }}>
                        {true && (
                          <IconButton
                            onClick={() => {
                              setSelectedRow(item);
                              setEditState(true);
                              console.log(item, 'item');

                              setValue("id", item?.id);
                              setValue("item_code", item?.item_code);
                              setValue("make", item?.make);
                              setValue("model", item?.model);
                              setValue("charges", item?.charges);
                              setValue("description", item?.description);
                              setValue("application_id", item?.application_id);
                              setValue("ref_no", item?.ref_no);
                              setValue("service", item?.service);
                              setServiceItem(item?.service);
                              setValue("quantity", item?.quantity);
                              console.log(item?.service);
                            }}
                          >
                            <EditIcon sx={{ fontSize: 28 }} />
                          </IconButton>
                        )}

                        {true && (
                          <IconButton
                            onClick={() => {
                              let selectedID = item?.id;
                              const filteredData = rows?.filter(item2 => item2?.id !== item?.id);
                              setRows(filteredData);

                              const total = filteredData.reduce((sum, item) => {
                                return sum + (parseFloat(item.total) || 0);
                              }, 0);

                              setPayments([]);
                              console.log("New total after update:", total);
                              setSubTotal(total);
                            }}
                          >
                            <DeleteIcon sx={{ fontSize: 28 }} />
                          </IconButton>
                        )}
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}

                <TableRow>
                  <TableCell colSpan={3} align="right">
                    <Typography variant="h6" sx={{ fontSize: "15px" }}>Sub-total:</Typography>
                  </TableCell>
                  <TableCell>
                    <Typography variant="h6" sx={{ fontSize: "15px" }}>{parseFloat(subTotal).toFixed(2)}</Typography> {/* Display the Sub-total */}
                  </TableCell>
                </TableRow>



                <TableRow>
                  <TableCell colSpan={10} align="right">
                    <Grid container gap={2} justifyContent={"center"}>
                      {<Button

                        onClick={() => submitForm2()}
                        disabled={rows?.length === 0}
                        variant="contained"
                        sx={{
                          width: "200px",
                          textTransform: "capitalize",
                          backgroundColor: "#001f3f",
                          ":hover": {
                            backgroundColor: "#001f3f",
                          },
                        }}
                      >
                        Place Invoice
                      </Button>}

                    </Grid>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

        </form>



      </Box>

    </>
  );
}

export default CreateServiceInvoice;
